<template>
  <div class="topbar-nav">
    <div class="container">
      <div class="logo-container clearfix float-left pad-r-md">
        <img class="logo-img" src="@/assets/logo.png" style="position:relative;top:-5px;">
        <span class="logo-name">数采系统管理中心 V2.0</span>
      </div>
      <el-popover
        ref="profile"
        placement="bottom-end"
        width="180"
        :visible-arrow="false"
        popper-class="popover-profile"
      >
        <div class="pad-y-xs">
          <div>
            <i class="fas fa-fw fa-user mar-x-xs"></i> 个人设置
          </div>
          <hr color="#d6d8da" size="1" class="mar-x-0" />
          <div class="cur-pointer" @click="onEditPwd">
            <i class="fas fa-fw fa-key mar-x-xs"></i> 修改密码
          </div>
          <hr color="#d6d8da" size="1" class="mar-x-0" />
          <div class="text-right pad-x-xs pad-t-sm">
            <el-button size="small" type="primary" class="pull-right" @click="logout">
              <i class="fa fa-lg fa-unlock-alt"></i> 退出</el-button>
          </div>
        </div>
      </el-popover>
      <div class="profile float-right pad-x-md" v-popover:profile>
        <big class="fas fa-user-circle fa-fw"></big>
        <span class="profile-name">{{user.Name}}</span>
      </div>
      <div class="profile float-right pad-x-md" @click="$router.push({ name: 'Exhibition' })">
        <big class="fa fa-fw fa-desktop"></big>
      </div>
      <div class="float-right bell pad-x-md" v-if="false">
        <el-badge :value="12" class="item">
          <i class="fa fa-bell fa-3x animated-hover faa-ring"></i>
        </el-badge>
      </div>
    </div>
    <el-dialog
      title="修改密码"
      width="480px"
      :visible="isVisible"
      append-to-body
      @close="closeDialog"
      :close-on-click-modal="false"
      >
      <el-form :model="itemModel" ref="form" label-width="100px" :rules="rules" class="item-space mar-t-sm pad-x-sm">
          <el-form-item label="旧密码：" prop="oldPwd">
            <el-input v-model="itemModel.oldPwd" type="password" placeholder="请输入旧密码"></el-input>
          </el-form-item>
          <el-form-item label="新密码：" prop="newPwd">
            <el-input v-model="itemModel.newPwd" type="password" placeholder="请输入新密码"></el-input>
          </el-form-item>
          <el-form-item label="确认密码：" prop="repetNewPwd">
            <el-input v-model="itemModel.repetNewPwd" type="password" placeholder="请再次输入新密码"></el-input>
          </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="isVisible = false">
          <i class="fas fa-fw fa-times" aria-hidden="true"></i> 取 消
        </el-button>
        <el-button type="primary" @click="onSaveItem" :disabled="isEditing">
          <i class="far fa-fw fa-save" aria-hidden="true"></i> 确 定
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  data() {
    // 新密码
    const valideNewPsw = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('新密码不能为空！'));
      } else {
        callback();
      }
    };
    // 确认密码
    const valideRepetNewPsw = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('新密码不能为空！'));
      } else if (this.itemModel.newPwd !== this.itemModel.repetNewPwd) {
        callback(new Error('两次密码不一致'));
      } else {
        callback();
      }
    };
    return {
      isVisible: false,
      isEditing: false,
      itemModel: {},
      rules: {
        oldPwd: [{ required: true, message: '旧密码不能为空', trigger: 'change, blur' }],
        newPwd: [{ required: true, validator: valideNewPsw, trigger: 'change, blur' }],
        repetNewPwd: [{ required: true, validator: valideRepetNewPsw, trigger: 'change, blur' }],
      },
    };
  },
  computed: {
    ...mapState({
      user: state => state.Auth.user,
    }),
  },
  methods: {
    onEditPwd() {
      this.isVisible = true;
      this.itemModel = this.getEmptyItem();
    },
    onSaveItem() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.isEditing = true;
          this.user.OldPassword = this.itemModel.oldPwd;
          this.user.Password = this.itemModel.newPwd;
          this.user.ConfirmPassword = this.itemModel.repetNewPwd;
          this.$axios.put('me', this.user)
            .then(() => {
              this.$message({
                message: '成功修改密码，之后请使用新密码登录系统',
                type: 'success',
              });
              this.closeDialog();
            }).catch(({ response }) => {
              this.$sys.alarmResponse(response);
            }).finally(() => {
              this.isEditing = false;
            });
        }
      });
    },
    closeDialog() {
      this.isVisible = false;
      this.itemModel = this.getEmptyItem();
    },
    // 信息清空
    getEmptyItem() {
      return {
        oldPwd: '',
        newPwd: '',
        repetNewPwd: '',
      };
    },
    logout() {
      this.$store.commit('Auth/Logout');
      this.$router.push('/login');
    },
  },
};
</script>

<style lang="scss">
@import "@/styles/variables.scss";

.topbar-nav {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: $topbar-nav-height;
  background-color: #23b7e5;
  color: #fff;
  z-index: 11;
  box-shadow: 0 1px 1px rgba(0,0,0,.15);
  > .container {
    margin: 0 auto;
    width: $container-width;
  }
  .logo-container {
    height: $topbar-nav-height;
    line-height: $topbar-nav-height;
    .logo-img {
      height: $topbar-nav-height * .75;
      width: $topbar-nav-height * .75;
      margin-right: 10px;
      vertical-align: middle;
    }
    .logo-name {
      font-weight: 700;
      font-size: 18px;
    }
  }
  .el-dropdown-link {
    cursor: pointer;
  }
  .profile {
    cursor: pointer;
    height: $topbar-nav-height;
    line-height: $topbar-nav-height;
    font-weight: 700;
    padding: 0 15px;
    border-left: 1px solid rgba(0,0,0,.05);
    cursor: pointer;
    .user-logo {
      width: 30px;
      height: 30px;
      vertical-align: middle;
      margin-right: 10px;
      border-radius: 50%;
    }
    .profile-name {
      font-weight: 700;
      font-size: 16px;
    }
  }
  .bell {
    .fa-bell {
      font-size: 20px;
    }
    .el-badge__content.is-fixed {
      top: 10px;
    }
  }
}
.popover-profile {
  margin-top: 0 !important;
  overflow: hidden;
}
</style>
